// extracted by mini-css-extract-plugin
export default {"loaderSection":"loaderBrown_loaderSection__ZVa7o","loaderSecitionh1":"loaderBrown_loaderSecitionh1__MoqnJ","lds_ring":"loaderBrown_lds_ring__v57rk"};